<app-nav-bar-pre-session></app-nav-bar-pre-session>
<main role="main">
  <app-side-bar [dynamicContent]="sideBarDynamicContent"></app-side-bar>
  <div class="router-content">
    <router-outlet class="page-content" tabindex="0"></router-outlet>
  </div>
</main>
<app-modal-container></app-modal-container>
<app-internet-check></app-internet-check>
@if (useAudioVideoConnectionMonitor) {
<app-audio-video-connection-monitor-v2></app-audio-video-connection-monitor-v2>
}
<app-footer></app-footer>
